import { useEffect, useRef } from 'react';
import { howItWorksSteps } from '../../../mocks/home';

export default function HowItWorks() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.15 }
    );

    const cards = sectionRef.current?.querySelectorAll('.fade-up');
    cards?.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <section id="como-funciona" ref={sectionRef} className="py-28" style={{ background: 'transparent' }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16 fade-up">
          <span
            className="inline-block px-4 py-1.5 rounded-full text-xs font-semibold mb-4"
            style={{ background: 'var(--badge-bg)', color: 'var(--gold-hover)', fontFamily: "'DM Sans', sans-serif", border: '1px solid rgba(200,131,42,0.15)' }}
          >
            Simples como enviar uma mensagem
          </span>
          <h2
            className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4"
            style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.03em' }}
          >
            Como sua música nasce
          </h2>
          <p
            className="text-base md:text-lg max-w-lg mx-auto"
            style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif", fontWeight: 300 }}
          >
            Em três passos simples, transformamos a história de quem você ama em uma composição única.
          </p>
        </div>

        <div className="fade-up mb-10 md:mb-14">
          <img
            src="/how-to-image.png"
            alt=""
            aria-hidden="true"
            loading="lazy"
            className="mx-auto block w-full max-w-5xl h-auto object-contain"
            style={{ maxHeight: 360 }}
          />
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-8 relative mt-8 md:mt-12">
          {howItWorksSteps.map((step, index) => {
            return (
              <div
                key={step.id}
                className="glass home-card fade-up relative flex flex-col items-center text-center rounded-[24px] md:rounded-[28px] group"
                style={{
                  backdropFilter: 'blur(18px)',
                  WebkitBackdropFilter: 'blur(18px)',
                  border: '1px solid rgba(255,145,77,0.08)',
                  boxShadow: '0 12px 30px rgba(0,0,0,0.04)',
                  transitionDelay: `${index * 0.15}s`,
                }}
              >
                {/* Conteúdo inferior */}
                <div className="p-7 md:p-8 flex flex-col items-center">
                  <div
                    className="mb-5 w-14 h-14 flex items-center justify-center rounded-2xl shadow-lg"
                    style={{ background: 'var(--badge-bg)', border: '2px solid var(--surface-white)' }}
                  >
                    <i className={`${step.icon} text-xl`} style={{ color: 'var(--gold)' }} />
                  </div>
                  <div
                    className="mb-4 text-[10px] uppercase font-bold tracking-widest px-3 py-1 rounded-full"
                    style={{ background: 'var(--cream)', color: 'var(--gold-hover)' }}
                  >
                    Passo {step.step}
                  </div>
                  <h3
                    className="text-xl font-bold mb-3"
                    style={{ color: 'var(--heading-ink)', fontFamily: "'DM Sans', sans-serif", fontWeight: 800, letterSpacing: '-0.02em' }}
                  >
                    {step.title}
                  </h3>
                  <p
                    className="text-sm leading-relaxed"
                    style={{ color: 'var(--text-strong)', fontFamily: "'DM Sans', sans-serif" }}
                  >
                    {step.description}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
